import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  selectShipFromMessage: {
    defaultMessage: 'Select Ship From',
    id: '9z8mW8',
    description: 'shipping preset ship from option placeholder label',
  },
});
